var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["factory"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "factoryId"
                          }
                        },
                        [
                          _c("a-select", {
                            attrs: {
                              options: _vm.factoryOptions,
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["factory"],
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.factoryId,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "factoryId", $$v)
                              },
                              expression: "model.factoryId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["danger.areaCode"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "areaCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              maxLength: "100",
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["danger.areaCode"],
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.areaCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "areaCode", $$v)
                              },
                              expression: "model.areaCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["danger.areaName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "areaName"
                          }
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "85%" },
                            attrs: {
                              maxLength: "100",
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["danger.areaName"],
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.areaName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "areaName", $$v)
                              },
                              expression: "model.areaName"
                            }
                          }),
                          _c(
                            "a-button",
                            {
                              staticStyle: { left: "3%" },
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.languageModelOpen(
                                    "EpBdFactoryArea",
                                    "areaName",
                                    _vm.areaNameLanguages
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.language"]))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("language-model", { ref: "languageModel", on: { ok: _vm.languageOk } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }